import { useEffect, useState } from 'react'
import DashboardBox from './DashboardBox'
import { AuditTrailReadModel } from '../GeneratedClients/FreeBillApi'
import { apiService } from '../apiService'
import AuditTrailsTable from './AuditTrailsTable'
import { HubConnection } from '@microsoft/signalr'
import DashboardSlider from './DashboardSlider'
import { auditTrailsFakeData } from './noContentFakeData'
import { useTranslate } from 'react-admin'

interface IProps {
  connection?: HubConnection
}

const AuditTrails = ({connection}: IProps) => {

  const [ auditTrails, setAuditTrails ] = useState<AuditTrailReadModel[]>([])
  const [ totalAuditTrails, setTotalAuditTrails ] = useState<number>(10)
  const [ noContent, setNoContent] = useState<boolean>(false)
  const [ refresh, setRefresh] = useState<boolean>(true)
  const translate = useTranslate()
  
  const fetchData = async() => {
    const { data: auditTrails } = await apiService.AuditTrailApi.getAuditTrails()
    auditTrails.length === 0 && setNoContent(true)
    setAuditTrails(auditTrails.length === 0 ? auditTrailsFakeData() : auditTrails)
  }

  connection?.on('InvoiceUpdated', (invoice) => {
    setRefresh(!refresh)
  })

  useEffect(() => {
    fetchData()
  }, [refresh])

  return (
    <DashboardBox 
      title={translate("resources.dashboard.auditTrails.title", {smart_count: totalAuditTrails})}
      slider={
        <DashboardSlider 
          label='Aktivitäten:'
          min={5}
          max={20}
          step={1}
          value={totalAuditTrails}
          setValue={setTotalAuditTrails}
        />
      }
      minWidth={"50%"}
      noContent={noContent ? translate("resources.dashboard.auditTrails.noContent") : undefined}
      content={[<AuditTrailsTable auditTrails={auditTrails} totalAuditTrails={totalAuditTrails} key={1} />]}
    />
  )
}

export default AuditTrails